import Vue from 'vue'
import Vuex from 'vuex'
import VuexORM from '@vuex-orm/core'

import Product from '@/models/product.model'
import Composition from '@/models/composition.model'
import Order from '@/models/order.model'
import CompositionOrder from '@/models/compositionOrder.model'

Vue.use(Vuex)

const database = new VuexORM.Database()
database.register(Product)
database.register(Composition)
database.register(Order)
database.register(CompositionOrder)

export default new Vuex.Store({
  state: {
    compositions: [{ plato: 123 }],
  },
  mutations: {},
  actions: {},
  modules: {},
  plugins: [VuexORM.install(database)],
})
